import store from "@/store";
import { CheckAuthorizeStatusAsync } from "./authService";

export async function editProfileAsync(user){
const url = `${process.env.VUE_APP_API_URL}Auth/EditProfile`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: JSON.stringify(user)
  });
  await CheckAuthorizeStatusAsync(response.clone());
  return response.json();
}

export async function editEmailAsync(user){
const url = `${process.env.VUE_APP_API_URL}Auth/ChangeEmail`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: JSON.stringify(user)
  });
  await CheckAuthorizeStatusAsync(response.clone());
  return response.json();
}

export async function editPasswordAsync(user){
const url = `${process.env.VUE_APP_API_URL}Auth/ChangePassword`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: JSON.stringify(user)
  });
  await CheckAuthorizeStatusAsync(response.clone());
  return response.json();
}


export async function deactivateAccountAsync(){
const url = `${process.env.VUE_APP_API_URL}Auth/Deactivate`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    }
  });
  await CheckAuthorizeStatusAsync(response);
  return response.json();
}